import ListTable from "./ListTable";

export default function ECSList() {
  return (
    <div>
      <ListTable />
    </div>
  );
}
